function findFirstPage(menuTree) {
  for (const node of menuTree || []) {
    if (node.path && node.menuType === "MENU" && node.component) return node.path;
    if (node.children && node.children.length) {
      const path = findFirstPage(node.children);
      if (path) return path;
    }
  }
  return "";
}

export function firstAccessiblePath(menuTree) {
  return findFirstPage(menuTree) || "/client/forbidden";
}

export function resolveLoginTarget(redirect, menuTree) {
  if (redirect && redirect !== "/client/forbidden") return redirect;
  return firstAccessiblePath(menuTree);
}
